import React from 'react';
import {ResponsivePie} from "@nivo/pie";
import NumbersUtil from "../../../global/utils/number";

export interface Props<T>{
    data:T,
}

function BaseTopGraph({ data }){

    function getShortenedLabel(id){
        let str = id.toString();
        if (str.length > 10){
            return str.slice(0,20) + '...';
        } else {
            return str;
        }
    }

    return (
        <ResponsivePie
            data={data}
            margin={{top: 40, right: 80, bottom: 80, left: 80}}
            colors={{scheme: "nivo"}}
            innerRadius={0.5}
            padAngle={0.7}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            borderWidth={1}
            borderColor={{from: 'color', modifiers: [['darker', 0.2]]}}
            enableArcLabels={false}
            arcLabel={d => {
                return `$${NumbersUtil.toShortened(d.value, 2)}`;
            }}
            arcLinkLabel={d => (
                <>
                    <tspan style={{font: "bold 12px sans-serif"}}>${NumbersUtil.toShortened(d.value, 2)}</tspan> - <tspan>{getShortenedLabel(d.id)}<title>{d.id}</title></tspan>
                </>
            ) as any}
            arcLinkLabelsSkipAngle={10}
            arcLinkLabelsTextColor="#333333"
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{from: 'color'}}
            arcLabelsSkipAngle={10}
            arcLabelsTextColor={{from: 'color', modifiers: [['darker', 2]]}}
            tooltip={({datum: {id, value, color, label}}) => (
                <div
                    style={{
                        padding: 12,
                        color,
                        background: '#222222',
                        borderRadius: 5,
                    }}
                >
                    <span>{label}</span>
                    <br/>
                    <strong>
                        ${NumbersUtil.toShortened(value, 2)}
                    </strong>
                </div>
            )}
        />
    )
}
export default BaseTopGraph;